import React, { Component } from "react";
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { useNavigate } from "react-router-dom";
import store from "@/redux/store";

import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from '@/components/dropdown'


import {switchTenant} from "@/reducers/Modal" 

export function PPC_Dropdown({...props}) {
    let tenants = props.data;
    const data = props.data;
const navi = useNavigate();
    
  const selectTenant = (tenantId) => {
    event.preventDefault();
    event.stopPropagation();
    
    store.dispatch(switchTenant(tenantId));    

//    .unwrap()
//   .then(() => {navi("/")})
//   .catch(error => 'handle error')
      
      
    return false;
  };


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

  return (
    <>

    <>
      {tenants && tenants.map((item) => (
        
                <DropdownItem key={item.key}>
                <div className="col-span-full ">
                <div className="flex items-left justify-between gap-x-6 ">
                  <DropdownLabel className="items-left">{item.name}</DropdownLabel>

                  
                  <div className="flex flex-none items-center gap-x-4">
            <a
              href="#"
              className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
              onClick={() => selectTenant(item.key)}
            >
              Open bedrijf<span className="sr-only">, {item.name}</span>
            </a>
                {(props.selected && props.selected == item.key) &&
                      <span className="inline-flex items-center rounded-md bg-green-50 px-1 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                        &nbsp;
                      </span>
                      }
                {(props.selected && props.selected != item.key) &&
                      <span className="inline-flex items-center  px-1 py-1 text-xs font-medium  ">
                        &nbsp;
                      </span>
                      }
            
                  </div>
                  </div>
                  </div>
                </DropdownItem>
        
        
        ))}
        </>


    </>
      );
}      


/*

        <li key={item.key} className="flex items-center justify-between gap-x-6 py-5">
          <div className="min-w-0">
            <div className="flex items-start gap-x-3">
              <p className="text-sm font-semibold leading-6 text-gray-900">{item.name}</p>
            </div>
          </div>
          <div className="flex flex-none items-center gap-x-4">
            <a
              href="#"
              className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
              onClick={() => selectTenant(item.id)}
            >
              Open bedrijf<span className="sr-only">, {item.name}</span>
            </a>
          </div>
        </li>

*/